import React from 'react';
import HomePageHeader from '../HomePageHeader';
import Footer from '../HomePageFooter';
import ImageHeading from './ImageHeading';

const Activities = () => {

    const renderActivitiesSection = () => {
        return (
            <section className='legal pt-5 pb-5'>
                <div className='container'>
                    <div className="row">
                        <div className="pr-heading aim">
                            <h1>
                                Activities
                            </h1>
                        </div>
                    </div>
                    <div className='row'>
                        <p className='text-bold w-100 mb-0'>NCC</p>
                        <p>
                            We have a platoon of N.C.C. In this the cadets are trained as per the academic instructions for it.
                            In this cadets do a whole gamut of operations including foot drill, Map reading, battle craft etc.
                            These cadets present a guard of Honor on Republic and Independence Days.
                        </p>
                        <p className='text-bold w-100 mb-0'>NSS (National Social Service-4 Units-3 Boys Units, 1 Girls Unit)</p>
                        <p>There are several contributions in this section that include cleaning of roads, blockages, debates on various topics such as ‘contribution of youths in the society’, sports activities, special care of Harijan Basti etc.</p>
                        <p className='text-bold w-100 mb-0'>Student Christian Movement</p>
                        <p>
                            SCM programme is run in all the Christian institutions mostly at undergraduate and postgraduate levels to make the students socially, morally and specially spritually aware of their surroundings and towards their duties and responsibilities.
                            Student Christian Movement of India is Offiliated to world Student Christian Federation.
                            SCM provides a wide scope of experiences through fellowship, group dynamics and lively learning through Biblical reflection, social analysis and cultural action to understand critiacally and participate creativity in the total life of the university and college.
                        </p>
                        <p>
                            Various National, Regional and Local programmes are arranged by Student Christian Movement of India.
                            At our local St. Andrew's College unit level, we have three staff advisors Prof. Samson Dan, Department of Geography, Dr. S.D.Sharma, Department of Chemictry and Mrs. R.N.Samuel, Department of Zoology to initiate, facilitate and Co-ordinate the SCM work.
                        </p>
                        <p className='text-bold w-100 mb-0'>Ranger and Rovers</p>
                        <p>
                            It will be worthwhile to highlight in this context that our college won first position in intercollegiate competition.
                            The experienced teacher in Law department Shri V.P.Singh and head of department of Education Department contributed immensely to the team effort by guiding the whole team.
                        </p>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <>
            <HomePageHeader />
            <ImageHeading heading='Activities' />
            {renderActivitiesSection()}
            <Footer />
        </>
    );
}

export default Activities;